'use client';
import { useEffect, useState } from 'react';

import { makeGetSheetManagerUseCase } from '@mais-retorno-front/core-business';
import { IManagerDetailsReturn } from '@mais-retorno-front/core-business/useCases/assests-manager/get-sheet-manager-usecase';
import { getSponsoredSheet } from '@mais-retorno-front/graphQl/queries/sponsored-sheet ';

// TODO: Essa interface não deveria fazer parte do ADs e sim da lamina do fundo
export interface ISheetFundsManagerDetails {
  name: string;
  director: string;
  email: string;
  phone: string;
  site: string;
}

interface ISponsoredSheet {
  cnpj: string;
  slug?: string;
}

export const useSponsoredSheets = ({ cnpj, slug }: ISponsoredSheet) => {
  const [data, setData] = useState({
    managerDetail: {
      name: null,
      director: null,
      email: null,
      phone: null,
      site: null,
    } as ISheetFundsManagerDetails,
    investmentList: [],
    monthlyReport: null,
    sponsoredVideo: null,
    youtubeId: null,
    isSponsored: false,
    fundDescriptionDocument: null,
    description: null,
    ctaContact: null,
  });

  const fetchData = async () => {
    const cleanedCnpj: string = cnpj?.replace(/[^\d]/g, '');

    const [managerDetailResponse, sponsoredSheetData] = await Promise.all([
      makeGetSheetManagerUseCase().execute(slug),
      getSponsoredSheet({ cnpj: cleanedCnpj }),
    ]);

    setData({
      managerDetail: {
        ...(managerDetailResponse as IManagerDetailsReturn),
        email:
          sponsoredSheetData?.asset_manager_email ||
          (managerDetailResponse as IManagerDetailsReturn)?.email,
        phone:
          sponsoredSheetData?.asset_manager_phone ||
          (managerDetailResponse as IManagerDetailsReturn)?.phone,
        site:
          sponsoredSheetData?.asset_manager_website ||
          (managerDetailResponse as IManagerDetailsReturn)?.site,
      },
      investmentList: sponsoredSheetData?.investmentList,
      monthlyReport: sponsoredSheetData?.monthly_report,
      sponsoredVideo: sponsoredSheetData?.video,
      isSponsored: sponsoredSheetData?.isSponsored,
      youtubeId: sponsoredSheetData?.video_youtube_id,
      fundDescriptionDocument: sponsoredSheetData?.fund_description_document,
      description: sponsoredSheetData?.fund_description,
      ctaContact: sponsoredSheetData?.contact_cta,
    });
  };

  useEffect(() => {
    fetchData();
  }, [cnpj, slug]);

  return data;
};
